module.exports = __webpack_public_path__ + "img/Group 427320384.32ad1562.svg";